import { Outlet } from "react-router-dom";
import PlansList from "./Plans";
import PlanDetails from "./PlanDetails";

export const adminPlansRoutes = [
  {
    path: "plans",
    element: Outlet,
    children: [
      {
        path: "",
        element: PlansList,
      },
      {
        path: "plan-details/:id",
        element: PlanDetails,
      },
    ],
  },
];
